import GetSeoData from "../../Helper/GetSeoData";
import "./AboutPage.css";

export default function AboutPage() {
  return (
    <>
      <section className="section-spacing-x section-spacing-x-mobile py-4">
        <GetSeoData type="About Us" id={null} />
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-5">
              <img
                src="https://store.bechofy.in/images/Beads_Beauty/ProductImages/215493-No_Image_Available-2.webp"
                className="img-fluid"
                alt=""
              />
            </div>
            <div className="col-lg-7">
              <h1>Heading</h1>
              <p className="fw-bold">
                Mauris blandit aliquet elit eget tincidunt nibh pulvinar uisque
                velit nisi pretium ut lacinia in elementum id enim velit nisi
                pretium elementum id enim.
              </p>
              <p>
                Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem.
                Donec rutrum congue leo eget malesuada. Praesent sapien massa,
                convallis a pellentesque nec, egestas non nisi. Quisque velit
                nisi, pretium ut lacinia in, elementum id enim.
              </p>
              <p>
                Curabitur arcu erat, accumsan id imperdiet et, porttitor at sem.
                Donec rutrum congue leo eget malesuada. Praesent sapien massa,
                convallis a pellentesque nec, egestas non nisi. Quisque velit
                nisi, pretium ut lacinia in, elementum id enim.
              </p>
              <a href="/contact-us" className="theme-btn">
                Contact Us
              </a>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
